module.exports = __webpack_public_path__ + "img/geocitieslight.png.927c82e6.webp";